<template>
	<span v-if="copyright" v-html="copyright" />
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps({
		label: {
			type: String,
			required: true,
		},
	});
	const copyright = computed(() => {
		const l = labels.get(props.label);
		return l ? l.replace('%YEAR%', new Date().getFullYear()) : '';
	});
</script>
